import React from 'react';
import {
    baseClasses,
    iconComponent,
    loadingStyles,
    sizeStyles,
    variantStyles,
} from 'src/domains/common/components/button/button-utils';
import { ButtonPropsType } from 'src/domains/common/components/button/button.types';
import { cn } from 'src/domains/common/components/utils';
import { observer } from 'src/utils/mobx-react';

export const Button = observer(
    'Button',
    ({
        children,
        className,
        dataTest,
        icon,
        isLoading = false,
        size = 'default',
        variant = 'primary',
        type = 'button',
        ...props
    }: ButtonPropsType) => {
        const variantClass = variantStyles(variant);
        const sizeClass = sizeStyles(size);
        const loadingClass = loadingStyles(isLoading);

        const iconClass = cn('size-4', {
            'animate-spin text-foreground': isLoading,
        });

        return (
            <button
                className={cn(baseClasses, variantClass, sizeClass, loadingClass, className)}
                data-test={dataTest}
                type={type}
                {...props}
            >
                {iconComponent(isLoading, icon, iconClass)}
                {children}
            </button>
        );
    }
);
